export const lawnCareData = {
    'December': {
        season: 'winter',
        sections: [
            {
                title: 'Equipment Maintenance',
                icon: '🔧',
                tasks: [
                    { text: 'Sharpen mower blades at repair shop (less busy in winter)', priority: 'medium' },
                    { text: 'Service lawn mower (tune-up, oil change, spark plugs)', priority: 'medium' },
                    { text: 'Clean and store garden tools properly', priority: 'low' },
                    { text: 'Check and maintain spreaders and sprayers', priority: 'low' }
                ]
            },
            {
                title: 'Planning & Assessment',
                icon: '📋',
                tasks: [
                    { text: 'Evaluate previous year\'s lawn performance', priority: 'medium' },
                    { text: 'Plan next year\'s lawn care budget', priority: 'low' },
                    { text: 'Research and order grass seed for spring (if needed)', priority: 'low' }
                ]
            },
            {
                title: 'Winter Protection',
                icon: '❄️',
                tasks: [
                    { text: 'Avoid foot traffic on frozen grass', priority: 'high' },
                    { text: 'Keep pathways clear to prevent compaction', priority: 'medium' },
                    { text: 'Remove heavy debris that could smother grass', priority: 'medium' }
                ]
            }
        ]
    },
    'January': {
        season: 'winter',
        sections: [
            {
                title: 'Soil Testing',
                icon: '🧪',
                tasks: [
                    { text: 'Conduct soil test if due (every 3-4 years for healthy lawns)', priority: 'high' },
                    { text: 'Send samples to UMass Extension Soil Testing Laboratory (or visit our Store for soil test kits)', priority: 'high' },
                    { text: 'Test for pH, nutrients, and organic matter content', priority: 'medium' }
                ]
            },
            {
                title: 'Equipment Prep',
                icon: '⚙️',
                tasks: [
                    { text: 'Continue equipment maintenance and repairs', priority: 'medium' },
                    { text: 'Check irrigation system components in garage/basement', priority: 'low' },
                    { text: 'Inventory fertilizers and lawn care products', priority: 'low' }
                ]
            },
            {
                title: 'Planning',
                icon: '📝',
                tasks: [
                    { text: 'Review soil test results when received', priority: 'high' },
                    { text: 'Plan lime applications if pH is below 6.0-7.0', priority: 'medium' },
                    { text: 'Design overseeding strategy for spring', priority: 'medium' }
                ]
            }
        ]
    },
    'February': {
        season: 'winter',
        sections: [
            {
                title: 'Late Winter Prep',
                icon: '🔨',
                tasks: [
                    { text: 'Finalize equipment servicing before spring rush', priority: 'high' },
                    { text: 'Order fertilizers and soil amendments based on soil test', priority: 'high' },
                    { text: 'Plan layout for any new lawn areas', priority: 'low' }
                ]
            },
            {
                title: 'Early Season Monitoring',
                icon: '👀',
                tasks: [
                    { text: 'Watch for snow mold as snow melts', priority: 'medium' },
                    { text: 'Avoid walking on frozen or waterlogged grass', priority: 'high' },
                    { text: 'Check for winter damage from salt or ice', priority: 'medium' }
                ]
            }
        ]
    },
    'March': {
        season: 'spring',
        sections: [
            {
                title: 'Spring Startup',
                icon: '🌱',
                tasks: [
                    { text: 'Rake lawn gently once snow recedes and ground is firm', priority: 'high' },
                    { text: 'Remove debris, leaves, and dead grass', priority: 'high' },
                    { text: 'Check for snow mold and winter damage', priority: 'medium' },
                    { text: 'Apply lime if recommended by soil test', priority: 'medium' }
                ]
            },
            {
                title: 'Equipment Setup',
                icon: '🚜',
                tasks: [
                    { text: 'Set mower deck to highest setting (3+ inches)', priority: 'high' },
                    { text: 'Test and prep all lawn equipment', priority: 'high' },
                    { text: 'Check irrigation system for winter damage', priority: 'medium' }
                ]
            },
            {
                title: 'Early Treatment',
                icon: '💊',
                tasks: [
                    { text: 'Apply fast-acting lime if soil test indicated need', priority: 'medium' },
                    { text: 'Prepare for pre-emergent herbicide application when soil temps reach 50-55°F', priority: 'high' }
                ]
            }
        ]
    },
    'April': {
        season: 'spring',
        sections: [
            {
                title: 'Pre-Emergent Control',
                icon: '🚫',
                tasks: [
                    { text: 'Apply pre-emergent herbicide for crabgrass when soil temperature consistently reaches 50-55°F', priority: 'critical' },
                    { text: 'Water in pre-emergent but avoid disturbing soil for 2 weeks', priority: 'high' },
                    { text: 'Monitor soil temperature with thermometer', priority: 'medium' }
                ]
            },
            {
                title: 'Spring Seeding',
                icon: '🌾',
                tasks: [
                    { text: 'Seed new areas when daytime temps hit 60s consistently', priority: 'high' },
                    { text: 'Best window: mid-April to early May', priority: 'high' },
                    { text: 'Ensure no spring rain is forecasted that could wash away seed', priority: 'medium' },
                    { text: 'Keep seeded areas consistently moist', priority: 'high' }
                ]
            },
            {
                title: 'First Maintenance',
                icon: '✂️',
                tasks: [
                    { text: 'Begin weekly mowing when grass reaches 4+ inches', priority: 'high' },
                    { text: 'Mow at highest setting (3-4 inches) to encourage deep roots', priority: 'critical' },
                    { text: 'Leave clippings on lawn for natural fertilization', priority: 'medium' }
                ]
            }
        ]
    },
    'May': {
        season: 'spring',
        sections: [
            {
                title: 'Peak Spring Care',
                icon: '🌿',
                tasks: [
                    { text: 'Apply first fertilizer application (slow-release nitrogen: 1-1.5 lbs per 1,000 sq ft)', priority: 'critical' },
                    { text: 'Core aeration if soil is compacted (May-June is ideal timing)', priority: 'high' },
                    { text: 'Dethatch if thatch layer exceeds ½ inch', priority: 'medium' }
                ]
            },
            {
                title: 'Irrigation Setup',
                icon: '💧',
                tasks: [
                    { text: 'Start watering schedule: 1 inch per week including rainfall', priority: 'high' },
                    { text: 'Test and activate irrigation system', priority: 'high' },
                    { text: 'Water deeply but less frequently to encourage deep roots', priority: 'medium' },
                    { text: 'Best watering time: 4-6 AM to minimize disease risk', priority: 'medium' }
                ]
            },
            {
                title: 'Weed Control',
                icon: '🌿',
                tasks: [
                    { text: 'Apply broadleaf weed control if needed (liquid spot treatment preferred)', priority: 'medium' },
                    { text: 'Target dandelions, clover, and other broadleaf weeds', priority: 'medium' },
                    { text: 'Follow up 4-6 weeks later if additional control needed', priority: 'low' }
                ]
            }
        ]
    },
    'June': {
        season: 'summer',
        sections: [
            {
                title: 'Grub Prevention 🚨 CRITICAL',
                icon: '🐛',
                tasks: [
                    { text: 'Apply preventive grub control (imidacloprid, clothianidin, or chlorantraniliprole)', priority: 'critical' },
                    { text: 'Best timing: mid-June to July for Massachusetts', priority: 'critical' },
                    { text: 'Water in thoroughly after application', priority: 'critical' },
                    { text: 'Focus on areas with previous grub damage', priority: 'high' }
                ]
            },
            {
                title: 'Summer Fertilization',
                icon: '🌱',
                tasks: [
                    { text: 'Apply second fertilizer if doing two applications per year', priority: 'medium' },
                    { text: 'Use Step 2 product (26-3-6) by June 15 if broadleaf weeds are present', priority: 'medium' },
                    { text: 'Apply maintenance fertilizer for ongoing nutrition', priority: 'medium' }
                ]
            },
            {
                title: 'Pest Monitoring',
                icon: '🔍',
                tasks: [
                    { text: 'Watch for early summer pests: billbugs, chinch bugs', priority: 'medium' },
                    { text: 'Monitor for fungal diseases in cool, wet periods (leaf spot, red thread)', priority: 'medium' },
                    { text: 'Treat grubs if populations exceed 5-7 per square foot', priority: 'high' }
                ]
            }
        ]
    },
    'July': {
        season: 'summer',
        sections: [
            {
                title: 'Heat Stress Management',
                icon: '🌡️',
                tasks: [
                    { text: 'Raise mower height to at least 3 inches (helps grass stay cool)', priority: 'critical' },
                    { text: 'Water deeply: 1 inch per week, early morning (5-9 AM)', priority: 'high' },
                    { text: 'Reduce foot traffic on stressed areas', priority: 'medium' },
                    { text: 'Avoid fertilizing dormant or heat-stressed grass', priority: 'high' }
                ]
            },
            {
                title: 'Disease Prevention',
                icon: '🦠',
                tasks: [
                    { text: 'Monitor for brown patch disease (peaks in July)', priority: 'high' },
                    { text: 'Ensure good air circulation around lawn', priority: 'medium' },
                    { text: 'Avoid evening watering to prevent fungal growth', priority: 'high' },
                    { text: 'Continue grub prevention applications if not done in June', priority: 'critical' }
                ]
            },
            {
                title: 'Maintenance',
                icon: '🔧',
                tasks: [
                    { text: 'Continue regular mowing (may slow to every 7-10 days in heat)', priority: 'medium' },
                    { text: 'Spot treat weeds as needed', priority: 'low' },
                    { text: 'Deep water rather than frequent shallow watering', priority: 'high' }
                ]
            }
        ]
    },
    'August': {
        season: 'summer',
        sections: [
            {
                title: 'Late Summer Prep',
                icon: '🔍',
                tasks: [
                    { text: 'Monitor for grub damage (look for irregular brown patches)', priority: 'high' },
                    { text: 'Check for chinch bug damage in hot, dry areas', priority: 'medium' },
                    { text: 'Plan fall overseeding strategy', priority: 'high' }
                ]
            },
            {
                title: 'Early Fall Preparation',
                icon: '🍂',
                tasks: [
                    { text: 'Continue deep watering if rainfall is insufficient', priority: 'high' },
                    { text: 'Avoid fertilizing unless irrigating regularly', priority: 'medium' },
                    { text: 'Begin planning for fall lawn renovation', priority: 'medium' }
                ]
            },
            {
                title: 'Late Summer Seeding',
                icon: '🌾',
                tasks: [
                    { text: 'Start overseeding late August (warm soil, cooler air ideal)', priority: 'high' },
                    { text: 'Combine with aeration for best seed-to-soil contact', priority: 'high' },
                    { text: 'Use cool-season grass mix appropriate for Massachusetts', priority: 'medium' }
                ]
            }
        ]
    },
    'September': {
        season: 'fall',
        sections: [
            {
                title: 'Prime Lawn Care Season 🌟 BUSIEST',
                icon: '⭐',
                tasks: [
                    { text: 'Core aeration (ideal timing: early September)', priority: 'critical' },
                    { text: 'Overseeding (must complete by October 15)', priority: 'critical' },
                    { text: 'Apply fall fertilizer #1 (around Labor Day)', priority: 'critical' },
                    { text: 'Dethatch if not done in spring', priority: 'medium' }
                ]
            },
            {
                title: 'Grub Control Follow-up',
                icon: '🐛',
                tasks: [
                    { text: 'Check for new grub populations (current year\'s hatch)', priority: 'high' },
                    { text: 'Apply curative treatment (Dylox) if more than 5-7 grubs per sq ft', priority: 'high' },
                    { text: 'Consider beneficial nematodes as eco-friendly option', priority: 'medium' }
                ]
            },
            {
                title: 'Renovation Projects',
                icon: '🏗️',
                tasks: [
                    { text: 'Major lawn renovations should start early September', priority: 'high' },
                    { text: 'Repair bare spots and thin areas', priority: 'high' },
                    { text: 'Apply starter fertilizer to newly seeded areas', priority: 'high' }
                ]
            }
        ]
    },
    'October': {
        season: 'fall',
        sections: [
            {
                title: 'Continued Fall Care',
                icon: '🍁',
                tasks: [
                    { text: 'Complete overseeding by October 15', priority: 'critical' },
                    { text: 'Apply lime after aeration if recommended', priority: 'medium' },
                    { text: 'Continue regular mowing as grass growth accelerates', priority: 'high' },
                    { text: 'Apply second fall fertilizer (6-8 weeks after first)', priority: 'high' }
                ]
            },
            {
                title: 'Leaf Management',
                icon: '🍂',
                tasks: [
                    { text: 'Begin leaf removal as they fall', priority: 'high' },
                    { text: 'Use mulching mower for light leaf cover', priority: 'medium' },
                    { text: 'Remove heavy leaf accumulation to prevent grass smothering', priority: 'high' },
                    { text: 'Compost excess leaves', priority: 'low' }
                ]
            },
            {
                title: 'Winter Preparation',
                icon: '❄️',
                tasks: [
                    { text: 'Continue watering new seed until established', priority: 'high' },
                    { text: 'Monitor for fall webworm and treat if necessary', priority: 'medium' },
                    { text: 'Plan winter equipment storage', priority: 'low' }
                ]
            }
        ]
    },
    'November': {
        season: 'fall',
        sections: [
            {
                title: 'Season Wrap-up',
                icon: '🏁',
                tasks: [
                    { text: 'Final fertilizer application (winterizer formula high in potassium)', priority: 'high' },
                    { text: 'Last mowing at 2-inch height to protect grass crowns', priority: 'critical' },
                    { text: 'Complete leaf removal', priority: 'high' },
                    { text: 'Final irrigation system check before shutdown', priority: 'medium' }
                ]
            },
            {
                title: 'Winter Preparation',
                icon: '🧊',
                tasks: [
                    { text: 'Drain and winterize irrigation system', priority: 'critical' },
                    { text: 'Clean and store lawn equipment', priority: 'high' },
                    { text: 'Apply winter fertilizer if not done earlier', priority: 'medium' }
                ]
            },
            {
                title: 'Final Tasks',
                icon: '✅',
                tasks: [
                    { text: 'Remove garden hoses and outdoor equipment', priority: 'medium' },
                    { text: 'Plan for next year\'s improvements', priority: 'low' },
                    { text: 'Order soil test kit for winter/spring testing', priority: 'low' }
                ]
            }
        ]
    }
};

export const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

export const getCurrentMonth = () => {
    const now = new Date();
    return monthNames[now.getMonth()];
};